<template>
  <popover v-show="value" :name="name" :pointer="pointer" :width="width" :maxWidth="maxWidth" :event="event"
    :delay="delay" :padding-left="paddingLeft" @show="value = $event.value">
    <div class="d-flex tooltip-content">
      {{ $t(value) }} <span class="icon" v-if="!!prefix" v-html="prefix"></span>
    </div>
  </popover>
</template>
<script>
export default {
  name: "Tooltip",
  props: {
    name: {
      type: String,
      default: "tooltip"
    },
    event: {
      type: String,
      default: "hover"
    },
    pointer: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 160
    },
    maxWidth: {
      type: [Number, String],
      default: 190
    },
    delay: {
      type: Number,
      default: 0
    },
    prefix: {
      type: String,
      default: ""
    },
    paddingLeft: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      value: ""
    };
  }
};
</script>
<style lang="scss" scoped>
.tooltip-content {
  display: flex;
  align-items: center;
  .icon {
    margin-left: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
